.speedbump {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 100;
    top: 0;
    left: 0;
    animation: speedbumpIn 250ms linear forwards;


    &__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
    }

    &__inner {
        position: absolute;
        width: 90%;
        max-width: 600px;
        background: #fff;
        padding-block: 40px;
		padding-inline: 40px;
        border-radius: 8px;
        
        button.close-speedbump {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          position: absolute;
          top: 1.5rem;
          right: 1.5rem;
          height: 1.75rem !important;
          width: 1.75rem;
          padding: 0 ;
          border: none;
          background: transparent;
          cursor: pointer;
          kdx-icon {
            width: 100%;
            height: 100%;
            svg {
                height: 100%;
                width: 100%;
            }
          }
        }
        h2,
        p {
          text-align: center;
          color: $gray-dark;
        }
        h2 {
          position: relative;
          padding-top: 1.5rem;
        }
    }

    &__actions {
        width: 100%;
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        a {
          margin-right: 20px;
          &.btn-underline {
            font-weight: 900;
            margin-top: 0.75rem;
            margin-bottom: 0.75rem;
          }
        }
    }
    @include media-breakpoint-down(md) {
	  &__inner {
		padding-block: 24px;
		padding-inline: 24px;
	  }
	
      &__actions {
        flex-direction: column;

        a { margin-right: unset; }

        .btn.btn-primary {
          margin-right: 0;
        }
        .btn.btn-tertiary {
          margin-right: 0;
          margin-top: 8px;
        }
      }
    }
}

@keyframes speedbumpIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
